import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { navigation } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

const { spacing } = THEME;

export const styleSheet = StyleSheet.create({
	disabledTabContent: {
		background: '#fff',
		minHeight: 300,
		position: 'relative',
	},
	integrationsSearchInput: {
		marginBottom: 20,
		maxWidth: 400,
		width: '100%',
	},
	tabList: {
		...CssSelectors.allChildren(
			{
				boxShadow: 'inset 0 -2px 0 0 currentColor, 0 1px 0 0 currentColor',
			},
			'button[data-state="active"]'
		),
	},
	tabViewContainer: {
		marginTop: 45,
		overflowY: 'auto',
	},
	unauthorized: {
		color: navigation,
		display: 'block',
		letterSpacing: 1.1,
		margin: '30px auto',
		textAlign: 'center',
		textTransform: 'uppercase',
	},
	noScrollViewContainer: {
		overflow: 'hidden',
		height: '90vh',
		minHeight: 900,
		paddingTop: spacing.md,
		...CssSelectors.allChildren(
			{
				minHeight: 900,
				...CssSelectors.allDescendants(
					{
						minHeight: 663,
					},
					'[class*="bodyContainer_"]'
				),
			},
			':first-child'
		),
	},
});
